
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class OpeningStockGrid extends Serenity.EntityGrid<OpeningStockRow, any> {
        protected getColumnsKey() { return 'Inventory.OpeningStock'; }
        protected getDialogType() { return OpeningStockDialog; }
        protected getIdProperty() { return OpeningStockRow.idProperty; }
        protected getInsertPermission() { return OpeningStockRow.insertPermission; }
        protected getLocalTextPrefix() { return OpeningStockRow.localTextPrefix; }
        protected getService() { return OpeningStockService.baseUrl; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate","Date");
        }

        protected addButtonClick() {
            
            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(2);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[2].AutoPosting;
            this.editItem(<OpeningStockRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 2,
                TransDate: now.toDateString(),
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });


            return filters;
        }

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}